import React from 'react';
import { AppButton, AppModal } from '../ui';

/**
 * Modale plein écran pour les aperçus BDC / Media Planning.
 */
const PlanDeComPreviewModal = ({
  show = false,
  title,
  subtitle = null,
  onClose,
  primaryAction = null,
  children,
}) => (
  <AppModal
    show={show}
    className="kkp-pdc-preview-modal"
    size="xl"
    scrollable
    dialogClassName="modal-fullscreen-lg-down"
    bodyClassName="bg-neutral-50"
    onClose={onClose}
    header={(
      <div className="modal-header flex-wrap gap-2">
        <div>
          <h5 className="modal-title mb-0">{title}</h5>
          {subtitle ? <div className="text-sm text-secondary-light mt-1">{subtitle}</div> : null}
        </div>
        <div className="d-flex flex-wrap align-items-center gap-2 ms-auto">
          {primaryAction ? (
            <AppButton
              size="sm"
              variant="danger"
              className="btn-danger-600"
              icon={primaryAction.icon || 'mdi:file-pdf-box'}
              disabled={primaryAction.disabled}
              onClick={primaryAction.onClick}
            >
              {primaryAction.label}
            </AppButton>
          ) : null}
          <button type="button" className="btn-close" aria-label="Fermer" onClick={onClose} />
        </div>
      </div>
    )}
    footer={<AppButton variant="outline-secondary" onClick={onClose}>Fermer</AppButton>}
  >
    {children}
  </AppModal>
);

export default PlanDeComPreviewModal;
